const getRuntimeMockFlag = () => {
  if (typeof window === "undefined") return undefined;
  return window.__ENV__?.MOCK_AUTHORIZATION_EXPORT;
};

const isTruthyFlag = (value) =>
  value === true || String(value).toLowerCase() === "true";

export const isAuthorizationExportMockEnabled = () =>
  isTruthyFlag(getRuntimeMockFlag()) ||
  isTruthyFlag(process.env.REACT_APP_MOCK_AUTHORIZATION_EXPORT);

const escapeHtml = (value = "") =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const getSigningDateText = (date = new Date()) =>
  `Ngày ${date.getDate()} tháng ${date.getMonth() + 1} năm ${date.getFullYear()}`;

const buildMockAuthorizationDocumentHtml = (payload = {}) => {
  const data = payload.data || {};

  return `
  <!doctype html>
  <html>
    <head>
      <meta charset="utf-8" />
      <title>Giấy ủy quyền</title>
      <style>
        body { font-family: "Times New Roman", serif; font-size: 14pt; line-height: 1.35; }
        .page { width: 720px; margin: 0 auto; }
        h1 { font-size: 18pt; margin: 32px 0; text-align: center; }
        .center { text-align: center; }
        .signature { margin-top: 32px; text-align: center; }
      </style>
    </head>
    <body>
      <div class="page">
        <h1>GIẤY ỦY QUYỀN</h1>
        <p><strong>Tôi/chúng tôi, ký tên dưới đây:</strong></p>
        <p class="center">
          ${escapeHtml(data.fullName)}<br />
          ${escapeHtml(data.address)}<br />
          Số CCCD: ${escapeHtml(data.identityNumber)}
        </p>
        <p><strong>File mẫu:</strong> ${escapeHtml(payload.templateUrl)}</p>
        <p>
          Bằng văn bản này ủy quyền và chỉ định tổ chức Đại diện Sở hữu công
          nghiệp: <strong>CÔNG TY TNHH MASTERBRAND</strong> làm đại diện hợp pháp.
        </p>
        <p>
          Giấy ủy quyền này có hiệu lực kể từ ngày ký cho đến ngày tuyên bố hết
          hiệu lực.
        </p>
        <div class="signature">
          <strong>Ký tại: ${escapeHtml(data.signingPlace)}</strong><br />
          ${getSigningDateText()}<br />
          Chủ đơn
          <br /><br /><br /><br />
          <strong>${escapeHtml(data.fullName)}</strong>
        </div>
      </div>
    </body>
  </html>
`;
};

const getMockFilename = (postId) =>
  `giay-uy-quyen-mock-${postId || Date.now()}.doc`;

export const createMockAuthorizationExportResponse = async (postId, payload) => {
  await new Promise((resolve) => setTimeout(resolve, 250));

  const filename = getMockFilename(postId);
  return {
    data: new Blob([buildMockAuthorizationDocumentHtml(payload)], {
      type: "application/msword;charset=utf-8",
    }),
    headers: {
      "content-disposition": `attachment; filename="${filename}"`,
    },
    status: 200,
  };
};
